/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendCodeAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SendCodeAction({
  children,
  viewPath = "/App/Auth/ResetPassword/SendCodeAction",
  onSubmit,
  isSubmitting
  
}) {
let resetPasswordSubmitData = fromData.useDataSubmit({ viewPath,
context: 'reset_password',
})
let resetPasswordIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'reset_password',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 size="large"
 data="reset_password"
 onClick={resetPasswordSubmitData}
 disabled={resetPasswordIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Send code"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}